import * as React from 'react';
import { clsx } from 'clsx';
import { findNotDisabledElement } from '../utils/findNotDisabledElement';
import { getDeviceStyles } from '../../styles/scrollTrack/getDeviceStyles';
import { useDeviceType } from '../../../../responsive/hooks/useDeviceType';
import { ScrollButton } from '../ScrollButton/ScrollButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ARROW_WIDTH = 48;
export const ScrollTrack = _ref => {
  let {
    children,
    setFocusVisible,
    activeTab
  } = _ref;
  const tabsListRef = React.useRef(null);
  const [needRightArrow, setNeedRightArrow] = React.useState(false);
  const [needLeftArrow, setNeedLeftArrow] = React.useState(false);
  const deviceType = useDeviceType();
  const styles = getDeviceStyles(deviceType);
  const handleScroll = _ref2 => {
    let {
      direction
    } = _ref2;
    const tabsList = tabsListRef.current;
    if (!tabsList) {
      return;
    }
    tabsList.scrollLeft = tabsList.scrollLeft + direction * tabsList.offsetWidth;
  };
  const scrollLeft = () => handleScroll({
    direction: -1
  });
  const scrollRight = () => handleScroll({
    direction: 1
  });
  const checkArrowsVisibility = () => {
    const tabsList = tabsListRef.current;
    if (!tabsList) {
      return;
    }
    const tabsListWidth = tabsList.scrollWidth;
    const containerWidth = tabsList.offsetWidth;
    const containerScrollLeft = tabsList.scrollLeft;

    // Показываем правую стрелку если табы не помещаются в ширину и не проскроленно до конца
    const needRightArrow = tabsListWidth > containerWidth && containerWidth + containerScrollLeft < tabsListWidth;
    const needLeftArrow = containerScrollLeft > 0;
    setNeedRightArrow(needRightArrow);
    setNeedLeftArrow(needLeftArrow);
  };
  const onScroll = () => checkArrowsVisibility();
  const handleKeyDown = event => {
    const {
      target
    } = event;
    const tabsList = tabsListRef.current;
    const role = target.getAttribute('role');
    if (role !== 'tab' || !tabsList) {
      return;
    }
    let newFocusTarget = null;
    setFocusVisible(true);
    switch (event.key) {
      case 'ArrowLeft':
        newFocusTarget = findNotDisabledElement({
          target: target,
          reverse: true
        }) || findNotDisabledElement({
          target: tabsList.lastChild,
          reverse: true,
          startWithTarget: true
        });
        break;
      case 'ArrowRight':
        newFocusTarget = findNotDisabledElement({
          target: target
        }) || findNotDisabledElement({
          target: tabsList.firstChild,
          reverse: false,
          startWithTarget: true
        });
        break;
      default:
        break;
    }
    if (newFocusTarget !== null) {
      newFocusTarget.focus();
      event.preventDefault();
    }
  };
  React.useEffect(() => {
    const scrollToActiveTab = () => {
      if (tabsListRef.current) {
        const childen = tabsListRef.current.childNodes;
        const activeChildenIndex = Object.keys(childen).find(index => {
          return childen[Number(index)].getAttribute('aria-selected') === 'true';
        });
        if (childen[Number(activeChildenIndex)]) {
          const trackScrollLeft = tabsListRef.current.scrollLeft;
          const trackWidth = tabsListRef.current.clientWidth;
          const itemOffsetLeft = childen[Number(activeChildenIndex)].offsetLeft;
          const itemWidth = childen[Number(activeChildenIndex)].clientWidth;
          if (itemOffsetLeft < trackScrollLeft + ARROW_WIDTH) {
            tabsListRef.current.scrollLeft = itemOffsetLeft - ARROW_WIDTH;
          }
          if (itemOffsetLeft + itemWidth >= trackScrollLeft + trackWidth - ARROW_WIDTH) {
            tabsListRef.current.scrollLeft = itemOffsetLeft - trackWidth + itemWidth + ARROW_WIDTH;
          }
        }
      }
    };
    checkArrowsVisibility();
    scrollToActiveTab();
  }, [deviceType, activeTab]);
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles['wrap'], needLeftArrow && styles['wrap-left-blur'], needRightArrow && styles['wrap-right-blur']),
    children: [needLeftArrow && /*#__PURE__*/_jsx(ScrollButton, {
      onClick: scrollLeft
    }), /*#__PURE__*/_jsx("div", {
      role: "tablist",
      ref: tabsListRef,
      onScroll: onScroll,
      className: clsx(styles['tabs']),
      onKeyDown: handleKeyDown,
      children: children
    }), needRightArrow && /*#__PURE__*/_jsx(ScrollButton, {
      onClick: scrollRight,
      right: true
    })]
  });
};